<template>
  <router-view />
</template>

<script setup lang="ts">
// Root App component - just renders the router view
</script>